/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';

import firstImg from "assets/img/tennis.png";
// import tennis_lab from "assets/img/tennis_lab.png";

let URL_API = "https://xs458763.xsrv.jp/api/";
let aTimeout = null;

function First(){

    const history = useHistory();

    if(window.sessionStorage.getItem("sessions") != null){
        let session = JSON.parse(window.sessionStorage.getItem("sessions"));
        if(session['name'] != ""){      
            if(session['userkind'] == "player"){
                history.push('../admin/user-page');
            }else if(session['userkind'] == "coach"){
                history.push('../coach/user');
            }else if(session['userkind'] == "parent"){
                history.push('../parent/user');
            }
        }
    }

    const onToApp = (e) => {
        if(aTimeout)
            clearTimeout(aTimeout);
        if(window.sessionStorage.getItem("sessions") != null){
            let session = JSON.parse(window.sessionStorage.getItem("sessions"));
            if(session['name'] != ""){      
                if(session['userkind'] == "player"){
                    history.push('../admin/user-page');
                }else if(session['userkind'] == "coach"){
                    history.push('../coach/user');
                }else if(session['userkind'] == "parent"){
                    history.push('../parent/user');
                }
            }
        }else{
            history.push('../user/login');
        }
    }

    useEffect(() => {
        aTimeout = setTimeout(function(){
            if(window.sessionStorage.getItem("sessions") != null){
                let session = JSON.parse(window.sessionStorage.getItem("sessions"));
                if(session['name'] != ""){      
                    if(session['userkind'] == "player"){
                        history.push('../admin/user-page');
                    }else if(session['userkind'] == "coach"){
                        history.push('../coach/user');
                    }else if(session['userkind'] == "parent"){
                        history.push('../parent/user');
                    }
                }
            }else{
                history.push('../user/login');
            }
        }, 5000);
    }, []);

    return (
        <>
            <div className="first-div" onClick={(e) => onToApp(e)}>
                <img src={firstImg} alt="react-logo" className="first-img"/>
                {/* <img className="tennis_lab" src={tennis_lab} /> */}
            </div>
        </>
    );

}

export default First;